import { useEffect, useState } from 'react';
import axios from 'axios';
import { BACKEND_URL } from '@/lib/backendUrl';
import defaults from '@/content/founderDefaults.json';

/** Static portraits are served by the frontend; admin-uploaded ones come from the API. */
export function resolvePhotoUrl(photoUrl) {
  if (!photoUrl) return '';
  if (/^https?:\/\//.test(photoUrl)) return photoUrl;
  return photoUrl.startsWith('/api/') ? `${BACKEND_URL}${photoUrl}` : photoUrl;
}

export function absolutePhotoUrl(photoUrl) {
  const resolved = resolvePhotoUrl(photoUrl);
  if (!resolved || /^https?:\/\//.test(resolved)) return resolved;
  return typeof window === 'undefined' ? resolved : `${window.location.origin}${resolved}`;
}

/** Public founder-page content: server copy (defaults + admin overrides), falling back to the shipped defaults. */
export function useFounderPage() {
  const [state, setState] = useState({ content: defaults.content, photoUrl: defaults.photo_url, loading: true, updatedAt: null, offline: false });
  useEffect(() => {
    let alive = true;
    axios.get(`${BACKEND_URL}/api/public/founder-page`)
      .then((r) => alive && setState({ content: r.data.content, photoUrl: r.data.photo_url, loading: false, updatedAt: r.data.updated_at, offline: false }))
      .catch((e) => { console.warn('founder page: using shipped defaults', e); alive && setState((s) => ({ ...s, loading: false, offline: true })); });
    return () => { alive = false; };
  }, []);
  return state;
}
